import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import { Component, Inject, LOCALE_ID, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LineChartSerie } from "../../../timeline/timeline-item/poll-result/poll-result.type";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PollSetupService } from "../../polls-setup.service";
import { tap } from "rxjs";
import { DatePipe, NgClass } from "@angular/common";
import { PollResultService } from "app/frontend/lib/timeline/timeline-item/poll-result/poll-result.service";
import {
    RecurringPollResultTrendsLineChartComponent
} from "../../../timeline/timeline-item/poll-result/recurring/recurring-poll-result-trends-line-chart/recurring-poll-result-trends-line-chart.component";
import {
    RecurringClosedPollResultTrendsChartComponent
} from "../../../timeline/timeline-item/poll-result/recurring/recurring-closed-poll-result-trends-chart/recurring-closed-poll-result-trends-chart.component";
import { UserService } from "@teammood/shared/util/user";
import { ITeam } from "@teammood/team";
import { MatTabsModule } from "@angular/material/tabs";
import { PollAvailableChoice, PollDetailsData, PollTrends } from "../user-polls.type";

@Component({
    selector: 'trend-poll-results-dialog',
    templateUrl: './trend-poll-results-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports:[
        NgClass,
        TranslateModule,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        MatTabsModule,
        RecurringPollResultTrendsLineChartComponent,
        RecurringClosedPollResultTrendsChartComponent
    ]
})
export class TrendPollResultsDialogComponent implements OnInit {
    protected dates: string[];
    protected locale: string;
    protected datePipe: DatePipe;
    protected poll: PollTrends;
    protected error: boolean = false;
    protected teams: ITeam[];
    protected series: LineChartSerie[];
    protected nullSeries: number;
    protected allTeamsAverageSerie: LineChartSerie;
    protected orderedValues: PollAvailableChoice[] = [];

    constructor(
        @Inject(LOCALE_ID) locale: string,
        @Inject(MAT_DIALOG_DATA) public data: PollDetailsData,
        public dialogRef: MatDialogRef<TrendPollResultsDialogComponent>,
        protected translate: TranslateService,
        private pollSetupService: PollSetupService,
        private pollResultService: PollResultService,
        private userService: UserService
    ) {
        this.locale = locale;
        this.datePipe = new DatePipe(this.locale);
     }

    ngOnInit() {
        this.userService.get().then(async (user) => {
            if (user) {
                this.teams = [...user.teams];
                this.pollSetupService.getPollTrend(this.data.pollAggregateId).pipe(
                    tap((pollDetails: PollTrends) => {
                        if (pollDetails.allResults) {
                            this.poll = pollDetails;
                            this.dates = this.pollResultService.formatPollTrendResultDates(this.poll.allResults.dates)
                            if (this.poll.itemType === 'closedQuestionResultItem') {
                                this.series = this.pollResultService.formatClosedPollTrendResult(this.poll.allResults.values, this.teams)
                                this.allTeamsAverageSerie = this.series.length === 1 ? this.series[0] : this.pollResultService.formatClosedPollAverageTrendResult(this.series)
                            } else {
                                this.series = this.pollResultService.formatPollTrendResultSeries(this.poll.allResults.values, this.teams)
                                this.nullSeries = this.series[0].data.filter(value => value === null).length;
                                this.orderedValues = pollDetails.availableChoices.sort((a, b) => b.position - a.position);
                            }
                        } else {
                            this.error = true;
                        }
                    }),
                ).subscribe();
            }
        })
    }

    close() {
        this.dialogRef.close();
    }

}

